(function () {
  "use strict";

  // ---------- row presets (key + color), sliced to however many rows are configured ----------
  let BASE_ROWS = [
    { key: "A", color: "#38d0ff" },
    { key: "S", color: "#2ee6a5" },
    { key: "D", color: "#9b6bff" },
    { key: "J", color: "#ff9f45" },
    { key: "K", color: "#ff5da2" },
    { key: "L", color: "#ffd23f" }
  ];
  let ROW_LABELS = ["A", "B", "C", "D", "E", "F"];

  let HIT_ZONE_FRACTION = 0.15;   // fraction of the lane width, from the left, where the hit zone is centered
  let HIT_ZONE_WIDTH_PX = 36;     // total width of the 3-line hit zone
  let DIAMOND_HALF_WIDTH_PX = 20; // approximate horizontal reach of the rotated diamond, for collision

  let DIFFICULTY_PRESETS = [
    { maxPerRow: 2, globalFracMin: 0.35, globalFracMax: 0.55, minGapFrac: 0.35 },
    { maxPerRow: 3, globalFracMin: 0.18, globalFracMax: 0.30, minGapFrac: 0.22 },
    { maxPerRow: 5, globalFracMin: 0.08, globalFracMax: 0.15, minGapFrac: 0.12 }
  ];

  // ---------- dom refs ----------
  let tracksEl = document.getElementById("tracks");
  let progressValueEl = document.getElementById("progress-value");
  let streakValueEl = document.getElementById("streak-value");
  let missesValueDisplayEl = document.getElementById("misses-value-display");
  let progressFillEl = document.getElementById("progress-fill");

  let startScreen = document.getElementById("start-screen");
  let passScreen = document.getElementById("pass-screen");
  let failScreen = document.getElementById("fail-screen");
  let keyHintEl = document.getElementById("key-hint");
  let passKeyHintEl = document.getElementById("pass-key-hint");
  let failKeyHintEl = document.getElementById("fail-key-hint");

  let rowsSlider = document.getElementById("rows");
  let rowsValueEl = document.getElementById("rows-value");
  let targetSlider = document.getElementById("target");
  let targetValueEl = document.getElementById("target-value");
  let missesSlider = document.getElementById("misses");
  let missesValueEl = document.getElementById("misses-value");
  let speedSlider = document.getElementById("speed");
  let speedValueEl = document.getElementById("speed-value");
  let difficultySlider = document.getElementById("difficulty");
  let difficultyValueEl = document.getElementById("difficulty-value");

  // ---------- state ----------
  let running = false;
  let rows = [];
  let rowCount = 3, targetHits = 24, missLimit = 6, speedPercent = 100, difficultyIdx = 1;
  let TRAVEL_MS = 1000;
  let progress = 0, streak = 0, misses = 0;
  let rafId = null;
  let nextGlobalSpawnAt = 0;
  let inputLockedUntil = 0;

  function rand(min, max) { return min + Math.random() * (max - min); }
  function clamp(v, min, max) { return Math.min(max, Math.max(min, v)); }

  // ---------- config labels ----------
  function updateRowsLabel() { rowsValueEl.textContent = rowsSlider.value; }
  function updateTargetLabel() { targetValueEl.textContent = targetSlider.value; }
  function updateMissesLabel() { missesValueEl.textContent = missesSlider.value; }
  function updateSpeedLabel() { speedValueEl.textContent = speedSlider.value + "%"; }
  function updateDifficultyLabel() {
    let labels = ["\uD83D\uDFE2", "\uD83D\uDFE1", "\uD83D\uDD34"];
    difficultyValueEl.textContent = labels[parseInt(difficultySlider.value, 10)];
  }

  rowsSlider.addEventListener("input", function () {
    updateRowsLabel();
    if (!running) buildTracks(true);
  });
  targetSlider.addEventListener("input", function () {
    updateTargetLabel();
    if (!running) updateStatDisplays();
  });
  missesSlider.addEventListener("input", function () {
    updateMissesLabel();
    if (!running) updateStatDisplays();
  });
  speedSlider.addEventListener("input", updateSpeedLabel);
  difficultySlider.addEventListener("input", updateDifficultyLabel);

  function setSlidersDisabled(disabled) {
    rowsSlider.disabled = disabled;
    targetSlider.disabled = disabled;
    missesSlider.disabled = disabled;
    speedSlider.disabled = disabled;
    difficultySlider.disabled = disabled;
  }

  function readConfig() {
    rowCount = parseInt(rowsSlider.value, 10);
    targetHits = parseInt(targetSlider.value, 10);
    missLimit = parseInt(missesSlider.value, 10);
    speedPercent = parseInt(speedSlider.value, 10);
    difficultyIdx = parseInt(difficultySlider.value, 10);
    TRAVEL_MS = 1000 / (speedPercent / 100);
  }

  function updateStatDisplays() {
    progressValueEl.textContent = progress + " / " + targetSlider.value;
    streakValueEl.textContent = streak;
    missesValueDisplayEl.textContent = misses + " / " + missesSlider.value;
    let target = parseInt(targetSlider.value, 10);
    let pct = target > 0 ? (progress / target) * 100 : 0;
    progressFillEl.style.width = clamp(pct, 0, 100) + "%";
  }

  // ---------- track construction ----------
  function buildTracks(previewOnly) {
    let count = previewOnly ? parseInt(rowsSlider.value, 10) : rowCount;
    tracksEl.innerHTML = "";
    rows = [];

    for (let i = 0; i < count; i++) {
      let base = BASE_ROWS[i];

      let rowEl = document.createElement("div");
      rowEl.className = "track-row";
      rowEl.style.setProperty("--row-color", base.color);

      let laneLabel = document.createElement("span");
      laneLabel.className = "lane-label";
      laneLabel.textContent = "TRACK " + ROW_LABELS[i];
      rowEl.appendChild(laneLabel);

      let centerLine = document.createElement("div");
      centerLine.className = "center-line";
      rowEl.appendChild(centerLine);

      let hitZone = document.createElement("div");
      hitZone.className = "hit-zone";
      hitZone.innerHTML = '<span class="hz-line"></span><span class="hz-line hz-mid"></span><span class="hz-line"></span>';
      rowEl.appendChild(hitZone);

      let keyBadge = document.createElement("div");
      keyBadge.className = "key-badge";
      keyBadge.textContent = base.key;
      rowEl.appendChild(keyBadge);

      tracksEl.appendChild(rowEl);

      rows.push({
        key: base.key,
        color: base.color,
        el: rowEl,
        diamonds: [],
        glowTimeout: null
      });
    }

    updateKeyHint();
  }

  function updateKeyHint() {
    let count = running ? rowCount : parseInt(rowsSlider.value, 10);
    let keys = BASE_ROWS.slice(0, count).map(function (r) { return r.key; });
    let spans = keys.map(function (k) { return '<span class="key">' + k + "</span>"; }).join("");
    keyHintEl.innerHTML = "TAP " + spans + " ON THE BEAT";
    passKeyHintEl.innerHTML = "TAP " + spans + " TO PLAY AGAIN";
    failKeyHintEl.innerHTML = "TAP " + spans + " TO TRY AGAIN";
  }

  // ---------- gameplay ----------
  function flashRow(row, good) {
    row.el.classList.remove("glow-good", "glow-bad");
    void row.el.offsetWidth; // force reflow so re-triggering restarts the effect
    row.el.classList.add(good ? "glow-good" : "glow-bad");
    if (row.glowTimeout) clearTimeout(row.glowTimeout);
    row.glowTimeout = setTimeout(function () {
      row.el.classList.remove("glow-good", "glow-bad");
    }, 220);
  }

  function spawnDiamond(row, now) {
    let el = document.createElement("div");
    el.className = "diamond";
    el.style.setProperty("--row-color", row.color);
    el.style.left = "100%";
    row.el.appendChild(el);
    row.diamonds.push({ el: el, spawnTime: now, resolved: false });
  }

  function registerHit(row, diamond) {
    diamond.resolved = true;
    diamond.el.classList.add("hit");

    flashRow(row, true);
    progress++;
    streak++;
    updateStatDisplays();

    if (progress >= targetHits) {
      endGame(true);
    }
  }

  // flash defaults to true (a mistimed keypress); pass false for a silently-expired diamond
  function registerMiss(row, flash) {
    misses++;
    streak = 0;
    updateStatDisplays();
    if (row && flash !== false) flashRow(row, false);

    if (misses >= missLimit) {
      endGame(false);
    }
  }

  function attemptHit(row) {
    let laneWidth = row.el.clientWidth;
    let zoneCenter = laneWidth * HIT_ZONE_FRACTION;
    let zoneLeft = zoneCenter - HIT_ZONE_WIDTH_PX / 2;
    let zoneRight = zoneCenter + HIT_ZONE_WIDTH_PX / 2;

    let best = null, bestDist = Infinity;

    for (let i = 0; i < row.diamonds.length; i++) {
      let d = row.diamonds[i];
      if (d.resolved) continue;
      let centerX = (d.currentXFrac || 0) * laneWidth;
      let left = centerX - DIAMOND_HALF_WIDTH_PX;
      let right = centerX + DIAMOND_HALF_WIDTH_PX;

      let overlaps = right >= zoneLeft && left <= zoneRight;
      if (overlaps) {
        let dist = Math.abs(centerX - zoneCenter);
        if (dist < bestDist) {
          best = d;
          bestDist = dist;
        }
      }
    }

    if (best) {
      registerHit(row, best);
    } else {
      registerMiss(row);
    }
  }

  function pickEligibleRow(preset) {
    let eligible = rows.filter(function (row) {
      let activeCount = 0;
      let hasNearDiamond = false;
      for (let i = 0; i < row.diamonds.length; i++) {
        let d = row.diamonds[i];
        if (d.resolved) continue;
        activeCount++;
        if (d.currentXFrac !== undefined && d.currentXFrac > 1 - preset.minGapFrac) {
          hasNearDiamond = true;
        }
      }
      return activeCount < preset.maxPerRow && !hasNearDiamond;
    });
    if (eligible.length === 0) return null;
    return eligible[Math.floor(Math.random() * eligible.length)];
  }

  // ---------- main loop ----------
  function gameLoop(timestamp) {
    if (!running) return;

    let preset = DIFFICULTY_PRESETS[difficultyIdx];

    for (let r = 0; r < rows.length; r++) {
      let row = rows[r];
      let laneWidth = row.el.clientWidth;
      let zoneCenter = laneWidth * HIT_ZONE_FRACTION;
      let zoneLeft = zoneCenter - HIT_ZONE_WIDTH_PX / 2;

      for (let i = row.diamonds.length - 1; i >= 0; i--) {
        let d = row.diamonds[i];
        let elapsed = timestamp - d.spawnTime;
        let xFrac = clamp(1 - elapsed / TRAVEL_MS, 0, 1);

        // always keep moving, hit or missed or still live — only the fill color differs
        d.currentXFrac = xFrac;
        d.el.style.left = xFrac * 100 + "%";

        if (!d.resolved) {
          // spatial miss: the diamond has fully passed the hit zone without being hit
          let centerX = xFrac * laneWidth;
          let diamondRight = centerX + DIAMOND_HALF_WIDTH_PX;
          if (diamondRight < zoneLeft) {
            d.resolved = true;
            registerMiss(row, false);
          }
        }

        if (elapsed >= TRAVEL_MS) {
          if (d.el.parentNode) d.el.parentNode.removeChild(d.el);
          row.diamonds.splice(i, 1);
        }
      }
    }

    if (timestamp >= nextGlobalSpawnAt) {
      let row = pickEligibleRow(preset);
      if (row) {
          spawnDiamond(row, timestamp);
        nextGlobalSpawnAt = timestamp + rand(preset.globalFracMin, preset.globalFracMax) * TRAVEL_MS;
      } else {
        nextGlobalSpawnAt = timestamp + 60; // every row was blocked, retry again shortly
      }
    }

    if (!running) return; // a hit/miss above may have just ended the game
    rafId = requestAnimationFrame(gameLoop);
  }

  // ---------- game flow ----------
  function resetGame() {
    readConfig();
    buildTracks(false);

    progress = 0;
    streak = 0;
    misses = 0;
    updateStatDisplays();

    running = true;
    setSlidersDisabled(true);
    startScreen.classList.add("hidden");
    passScreen.classList.add("hidden");
    failScreen.classList.add("hidden");

    let now = performance.now();
    nextGlobalSpawnAt = now + rand(0.05, 0.15) * TRAVEL_MS;

    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(gameLoop);
  }

  function endGame(won) {
    running = false;
    if (rafId) cancelAnimationFrame(rafId);
    setSlidersDisabled(false);
    inputLockedUntil = performance.now() + 1000;

    if (won) {
      passScreen.classList.remove("hidden");
    } else {
      failScreen.classList.remove("hidden");
    }
  }

  // ---------- input ----------
  window.addEventListener("keydown", function (e) {
    if (e.repeat) return;

    let k = e.key.length === 1 ? e.key.toUpperCase() : e.key;

    if (!running) {
      let count = parseInt(rowsSlider.value, 10);
      let validKeys = BASE_ROWS.slice(0, count).map(function (r) { return r.key; });
      if (validKeys.indexOf(k) === -1) return;

      let onEndScreen = !passScreen.classList.contains("hidden") || !failScreen.classList.contains("hidden");
      if (onEndScreen && performance.now() < inputLockedUntil) return;
      resetGame();
      return;
    }

    for (let i = 0; i < rows.length; i++) {
      if (rows[i].key === k) {
        e.preventDefault();
        attemptHit(rows[i]);
        break;
      }
    }
  });

  // ---------- initial paint ----------
  updateRowsLabel();
  updateTargetLabel();
  updateMissesLabel();
  updateSpeedLabel();
  updateDifficultyLabel();
  buildTracks(true);
  updateStatDisplays();
})();